import MainTitle from '../../common/MainTitle';
import ImageLink from '../../../js/utils/ImageLink';
import Icon from '../../common/Icon';

export default function CoursesCatalog({ titles, data }) {
  return (
    <section className="courses-catalog">
      <MainTitle type="dark" className="text--2xl container hidden--lg">
        <span>{titles?.title1}</span>
        <span className="decorated-line decorated-line--dark decorated-line--left">
          {titles?.title2}
        </span>
      </MainTitle>

      <div className="courses-catalog__container container">
        <div className="courses-catalog__content">
          <MainTitle type="dark" className="text--2xl container hidden--md">
            <span>{titles?.title1}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {titles?.title2}
            </span>
          </MainTitle>

          <div className="courses-catalog__description">
            <p className="description">{data?.description}</p>

            {!!data?.downloadFile && (
              <a
                className="courses-catalog__download"
                href="/Course_Catalog.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download>
                <Icon name="download" />
                <span>{data?.linkText}</span>
              </a>
            )}
          </div>
        </div>
        {data?.image && (
          <div className="courses-catalog__media">
            <img src={ImageLink(data?.image.url)} alt={data?.image.alt} />
          </div>
        )}
      </div>
    </section>
  );
}
